<template>
  <div class="container is-max-desktop login-page">
    <p>Fuldfører Google-login…</p>
    <AuthenticateWithRedirectCallback
      sign-in-fallback-redirect-url="/"
      sign-up-fallback-redirect-url="/"
    />
    <div id="clerk-captcha" />
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { AuthenticateWithRedirectCallback } from '@clerk/vue'

export default defineComponent({
  components: {
    AuthenticateWithRedirectCallback
  }
})
</script>
